import axios from "axios";
import {
  linksRoleRequested,
  linksRoleRequestSucceeded,
  linksRoleRequestFailed,
} from "../slices/GetLinksRoleByCountrySlice";

const selectedCountry = localStorage.getItem("selectedCountry");

const apiUrl = `${
  process.env.REACT_APP_BASE_API_URL
}/api/Menu/GetLinksRoleByCountry?country=${encodeURIComponent(selectedCountry)}`;

const ApiKey = process.env.REACT_APP_BASE_API_KEY;

export const GetLinksRoleByCountry = () => async (dispatch) => {
  try {
    dispatch(linksRoleRequested());

    const axiosConfig = {
      headers: {
        ApiKey: ApiKey,
        "Content-Type": "application/json",
      },
    };
    const response = await axios.get(apiUrl, axiosConfig);

    dispatch(linksRoleRequestSucceeded(response.data));
  } catch (error) {
    dispatch(linksRoleRequestFailed(error.message));
  }
};
